import { Fetch } from 'lib';
import type { PageBuilderBanner, PageSettingCode } from 'types';

type RequestResponses = {};

type RequestParameters = {};

type RequestBody = {
  code: PageSettingCode;
  banners: PageBuilderBanner[];
};

const updatePageBanners = async (body: RequestBody) =>
  await Fetch<RequestResponses, RequestParameters, RequestBody>({
    url: 'adminPageBuilder/updatePageBanners',
    method: 'PATCH',
    body,
  });

export { updatePageBanners };
